import React, { Component } from 'react';
import JalaliUtils from '@date-io/jalaali';
import { addField, FieldTitle } from 'ra-core';
import { DateTimePicker, MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import jMoment from 'moment-jalaali';
jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

class _IdateTimeInput extends Component {
  onChange = date => {
    this.props.input.onChange(date);
    this.props.input.onBlur();
  };
  render() {
    const {
      input,
      options,
      label,
      source,
      resource,
      isRequired,
      className,
      meta,
      providerOptions
    } = this.props;
    const { touched, error } = meta;
    return (
      <div className='picker'>
        <MuiPickersUtilsProvider {...providerOptions}>
          <DateTimePicker
            variant="outlined"
            {...options}
            inputProps={{ style: { fontSize: 10 } }}
            label={
              <FieldTitle
                label={label}
                source={source}
                resource={resource}
                isRequired={isRequired}
              />
            }
            labelFunc={date =>
              date ? date.format('jYYYY/jMM/jDD hh:mm A') : ''
            }
            margin='normal'
            error={!!(touched && error)}
            helperText={touched && error}
            ref={node => {
              this.picker = node;
            }}
            className={className}
            value={input.value ? input.value : null}
            onChange={date => {
              this.onChange(new Date(date));
            }}
          />
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

class _IdateInput extends Component {
  onChange = date => {
    this.props.input.onChange(date);
    this.props.input.onBlur();
  };
  render() {
    const {
      input,
      options,
      label,
      source,
      resource,
      isRequired,
      className,
      meta,
      providerOptions
    } = this.props;
    const { touched, error } = meta;
    return (
      <div className='picker'>
        <MuiPickersUtilsProvider {...providerOptions}>
          <DatePicker
            variant="outlined"
            {...options}
            label={
              <FieldTitle
                label={label}
                source={source}
                resource={resource}
                isRequired={isRequired}
              />
            }
            labelFunc={date =>
              date ? date.format('jYYYY/jMM/jDD') : ''
            }
            padding='0'
            error={!!(touched && error)}
            helperText={touched && error}
            ref={node => {
              this.picker = node;
            }}
            className={className}
            value={input.value ? input.value : null}
            onChange={date => {
              this.onChange(new Date(date));
            }}
          />
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

// const days = [
//   'یک‌شنبه',
//   'دوشنبه',
//   'سه‌شنبه',
//   'چهارشنبه',
//   'پنج‌شنبه',
//   'جمعه',
//   'شنبه'
// ]

_IdateTimeInput.defaultProps = {
  input: {},
  isRequired: 'false',
  meta: { touched: false, error: false },
  options: {},
  resource: '',
  source: '',
  labelTime: '',
  className: '',
  providerOptions: {
    utils: JalaliUtils,
    locale: 'fa'
  }
};

_IdateInput.defaultProps = {
  input: {},
  isRequired: 'false',
  meta: { touched: false, error: false },
  options: {},
  resource: '',
  source: '',
  labelTime: '',
  className: '',
  providerOptions: {
    utils: JalaliUtils,
    locale: 'fa'
  }
};

export const IdateTimeInput = addField(_IdateTimeInput);
export const IdateInput = addField(_IdateInput);
